<accordion>
  @for (loa of accountTypes; track loa; let i = $index) {
    <accordion-group class="list-accounts" #accGroup>
      <span accordion-heading>
        <div class="account-items  d-flex align-items-center {{getSelectedAccount()?.code === loa.code ?'loan-selected-account':''}}"
          (click)="getAccountsByGL(loa, !accGroup?.isOpen && loa.subAccounts.length == 0)">
          @if (loadAccount||loa.subAccounts.length != 0) {
            <button class="btn" type="button" id="{{loa.code+i}}">
              <em class="fa font-25"
                [ngClass]="{'fa-minus-square-o': accGroup?.isOpen, 'fa-plus-square-o': !accGroup?.isOpen}">
              </em>
            </button>
          }
          <span class="account-parent-name mt-10 level-{{level}} font-bold" id="level-{{level}}"> {{loa.code}}
            - {{loa.name}}
          </span>
          @if (loa.subAccounts.length == 0 && allowSelectAccountType) {
            <input
              type="checkbox"
              (click)="$event.stopPropagation()"
              (change)="changeAccountTypeStatus(loa, $event)"
              class="account-checkbox"
              [checked]="getSelectedAccount()?.code === loa.code">
          }
        </div>
      </span>
      @if (loa.subAccounts.length !== 0) {
        <div>
          @if (level<=maxLevel) {
            <app-user-account-list-node [accountTypes]="loa.subAccounts"
              [selectedAccount]="getSelectedAccount()" [level]="level + 1" [maxLevel]="maxLevel"
              [hideClosedAccount]="hideClosedAccount"
              [loadAccount]="loadAccount" [allowSelectAccountType]="allowSelectAccountType"
              [currency]="currency"
              (addAccount)="addAccountItem($event)" (deleteAccountFromList)="removeAccount()"
              (addAccountType)="addAccountTypeItem($event)"
              [isForeignCurrencyAccount]="isForeignCurrencyAccount">
            </app-user-account-list-node>
          }
        </div>
      }
      @if (loa.subAccounts.length == 0 && accounts[loa.code]) {
        <div class="last-level">
          <accordion style="margin-top:5px;">
            @for (it of accounts[loa.code]; track it) {
              <accordion-group class="list-accounts align-items-start">
                <div accordion-heading class="flex align-items-center font-13">
                        <div class="account-items
                        loan-account-item {{getSelectedAccount()?.number === it.number ?'loan-selected-account':''}}"
                    (click)="composeAccounts(it)" id="last-level-{{it.number}}">
                    <span>{{it.name}}</span> <span> {{it.number}}</span> <span> {{it.currency.isoCode}}</span>
                  </div>
                  <input type="checkbox" (change)="changeAccountStatus($event, it)" class="account-checkbox"
                    [checked]="getSelectedAccount()?.number === it.number">
                  </div>
                </accordion-group>
              }
            </accordion>
            @if (totalElements[loa.code] > pageSizes[loa.code]) {
              <p-paginator
                [rows]="pageSizes[loa.code]" 
                [totalRecords]="totalElements[loa.code]"
                [rowsPerPageOptions]="[10, 25, 50]"
                (onPageChange)="paginateAccounts($event, loa)">
              </p-paginator>
            }
          </div>
        }
      </accordion-group>
    }
  </accordion>